import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { CHANGE_PASSWORD } from "./actionTypes";
import { userChangePasswordSuccess, userChangePasswordError } from "./actions";

// Include call API
import { getUsersAPI } from "../../../api/users";

const usersAPI = getUsersAPI();

//If user is send successfully send mail link then dispatch redux action's are directly from here.
function* changePwdUser({ payload: { user, pass, token, history } }) {
  try {
    const response = yield call(usersAPI.changePassword, user, pass, token);
    yield put(userChangePasswordSuccess(response.user));
    // history.go();
  } catch (error) {
    console.log(error)
    yield put(userChangePasswordError(error));
  }
}

export function* watchUserChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, changePwdUser);
}

function* changePasswordSaga() {
  yield all([fork(watchUserChangePassword)]);
}

export default changePasswordSaga;
